import React, { FC } from 'react';
import { Avatar, ListItem, ListItemAvatar, ListItemText, Text } from '@maas-components/core';
import { PersonOutline } from '@maas-components/icons';
import useStyles from '../styles';

export type UserInfoProps = {
    name: string;
    email: string;
    mode: 'dark' | 'light';
};

const UserInfo: FC<UserInfoProps> = ({ mode, name, email }) => {
    const classes = useStyles({ mode });
    return (
        <ListItem alignItems="flex-start" className={classes.avatarListItem}>
            <ListItemAvatar>
                <Avatar alt={name} className={classes.avatarUserInfo}>
                    <PersonOutline fontSize="large" />
                </Avatar>
            </ListItemAvatar>
            <ListItemText
                style={{ marginLeft: 16 }}
                primary={
                    <Text component="span" color="textPrimary" className={classes.listItemTitle}>
                        <strong> {name} </strong>
                    </Text>
                }
                secondary={
                    <Text
                        component="span"
                        fontWeight="regular"
                        fontSize="xsmall"
                        color="textSecondary"
                        className={classes.listItemTitle}
                    >
                        {email}
                    </Text>
                }
            />
        </ListItem>
    );
};

export default UserInfo;
